import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/views/home')
const release = () => import('@/views/release')
const postDetails = () => import('@/views/post-details')
const login = () => import('@/views/login')
const register = () => import('@/views/register')
const search = () => import('@/views/search')
const users = () => import('@/views/users')
const account = () => import('@/views/account')

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      name: 'search',
      path: '/search',
      component: search
    },
    {
      name: 'account',
      path: '/account/:uri/:uriChild?',
      component: account,
      props: true
    },
    {
      path: '/account',
      redirect: '/account/profile/base'
    },
    {
      name: 'users',
      path: '/users/:url/:uid',
      component: users
    },
    {
      name: 'release',
      path: '/release/:uid',
      component: release
    },
    {
      name: 'postDetails',
      path: '/p/:filename',
      component: postDetails,
      props: true
    },
    {
      name: 'login',
      path: '/login',
      component: login
    },
    {
      name: 'register',
      path: '/register',
      component: register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js